import { useEffect } from "react";

export const ebookPath = "/ebook-restaurantes-saudaveis-fortaleza.pdf";
export const ebookFilename = "Ebook de restaurantes saudáveis em Fortaleza.pdf";

let downloadStarted = false;

const startDownload = () => {
  const link = document.createElement("a");
  link.href = ebookPath;
  link.download = ebookFilename;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const EbookRestaurantes = () => {
  useEffect(() => {
    if (downloadStarted) return;
    downloadStarted = true;
    startDownload();
  }, []);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-bege px-6 text-center">
      <h1 className="text-2xl text-bordo font-bold">
        Ebook de restaurantes saudáveis em Fortaleza
      </h1>
      <p className="mt-3 max-w-md text-lg text-zinc-600">
        O download começa automaticamente. Se o arquivo não baixar, use o botão abaixo.
      </p>
      <a
        href={ebookPath}
        download={ebookFilename}
        className="mt-8 w-64 rounded-md bg-bordo px-5 py-5 text-center text-lg text-white shadow-lg duration-300 hover:bg-laranja"
      >
        Baixar ebook
      </a>
    </main>
  );
};

export default EbookRestaurantes;
